import { render } from "./UploadUserManually.vue?vue&type=template&id=486ff37c"
import script from "./UploadUserManually.vue?vue&type=script&lang=js"
export * from "./UploadUserManually.vue?vue&type=script&lang=js"

import "./UploadUserManually.vue?vue&type=style&index=0&id=486ff37c&lang=css"

import exportComponent from "/app/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__